export default {
  'creditTicket.creditpayment': 'پرداخت اعتباری شما به مبلغ',
  'creditTicket.creditsuccesspayment': 'تومان با موفقیت انجام شد',
  'creditTicket.flightrezerv': 'رزرو موقت پرواز شما در حال انجام شدن است',
  'creditTicket.reservtime': 'به تاریخ',
  'creditTicket.reservcarefulcredit': 'اعتبار رزرو',
  'creditTicket.reservtimecareful': 'دقت فرمایید',
  'creditTicket.beforesalecareful': 'قبل از تاریخ صادر فرمایید',
  'creditTicket.successreserve': 'رزرو شما با موفقیت انجام شد',
  'creditTicket.followupnumber': 'شماره پیگیری',
  'creditTicket.reservationdeadline': 'مهلت رزرو',
  'creditTicket.equipmentname': 'شماره رفرنس',
  'creditTicket.Cabinname': 'کلاس نرخی پرواز',
  'creditTicket.flightnumber': 'نوع هواپیما',
  'creditTicket.cancellationofreservation': 'ابطال رزرو ',
  'creditTicket.iwillpaylater': 'بعدا پرداخت میکنم',
  'creditTicket.paymentandissue': 'پرداخت و صدور',
  'creditTicket.allowableload': 'بار مجاز',
};
